// extracted by mini-css-extract-plugin
export default {"stepper":"AddEmployeeSteppers_stepper__xSxz2","icon":"AddEmployeeSteppers_icon__F4AsW"};